import React, { useRef, useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useHistory, useLocation } from "react-router";

import { EntranceUser_initialize, EntranceUserSet, MiddleUser } from "../../stores/slices/EntranceUser";

const EntranceUser = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const Params = useParams();

    const informationState = useSelector((state) => state.Information);
    const EntranceUserState = useSelector((state) => state.EntranceUser);
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        //ログイン済みならトップページへ
        if(informationState["organizer"]["user_login"] === true)
        {
            history.push(`/`);
            return;
        }

        dispatch(EntranceUser_initialize());

        //仕様変更によりYahooID連携機能廃止
        // //Yahoo連携時に値をセット
        // if(Object.keys(Params).length === 9)
        // {
        //     if(Params['email_address'].trim() !== '')
        //     {
        //         dispatch(EntranceUserSet(['email_address', Params['email_address']]));
        //     }
        //     if(Params['last_name'].trim() !== '')
        //     {
        //         dispatch(EntranceUserSet(['last_name', Params['last_name']]));
        //     }
        //     if(Params['first_name'].trim() !== '')
        //     {
        //         dispatch(EntranceUserSet(['first_name', Params['first_name']]));
        //     }
        //     if(Params['last_name_kana'].trim() !== '')
        //     {
        //         dispatch(EntranceUserSet(['last_name_kana', Params['last_name_kana']]));
        //     }
        //     if(Params['first_name_kana'].trim() !== '')
        //     {
        //         dispatch(EntranceUserSet(['first_name_kana', Params['first_name_kana']]));
        //     }
        //     if(Params['postal_code'].trim() !== '')
        //     {
        //         dispatch(EntranceUserSet(['postal_code', Params['postal_code']]));
        //     }
        //     if(Params['prefecture'].trim() !== '')
        //     {
        //         dispatch(EntranceUserSet(['prefecture', Params['prefecture']]));
        //     }
        //     if(Params['city'].trim() !== '')
        //     {
        //         dispatch(EntranceUserSet(['city', Params['city']]));
        //     }
        //     if(Params['yahoo_token'].trim() !== '')
        //     {
        //         dispatch(EntranceUserSet(['yahoo_token', Params['yahoo_token']]));
        //     }
        //     //EntranceUserのYahoo連携からの遷移時のみ、メール送信
        //     if(localStorage.getItem("EntranceUser"))
        //     {
        //         dispatch(EntranceUserSet(['yahoo_flag', true]));
        //     }
        //     localStorage.removeItem("EntranceUser");
        // }
    }, [informationState, Params]);

    //送信ボタン
    const HandleSubmit = (e) => {
        e.preventDefault();

        // if(!EntranceUserState.checked)
        // {
        //     alert("利用契約・プライバシーポリシーに同意の上、お進みください。");
        //     return;
        // }
        setDisabled(true);

        //メール送信
        sendMail();
    };

    //メール送信処理
    const sendMail = () => {
        dispatch(MiddleUser(EntranceUserState)).then((data) => {
            const result = data.payload.result;
            console.log(result);
            if(result === 'OK')
            {
                //メール送信後、画面表示を切り替える
                dispatch(EntranceUserSet(['send', true]));
            }
            else
            {
                //NGメッセージ表示
                alert(data.payload.message);
            }
            setDisabled(false);
        });
    }

    //仕様変更によりYahooID連携機能廃止
    // //EntranceUserのYahoo連携からの遷移時のみ、メール送信
    // if(EntranceUserState.yahoo_flag)
    // {
    //     dispatch(EntranceUserSet(['yahoo_flag', false]));
    //     sendMail();
    // }

    //値変更
    const onChange = (params) => {
        const { name, value } = params;
        dispatch(EntranceUserSet([name, value]));
    };

    //戻る
    const LinkClick = () => {
        history.push(`/`);
    };

    //仕様変更によりYahooID連携機能廃止
    // //YahooID連携
    // const YahooSubmit = (e) => {
    //     e.preventDefault();
    //     if(!EntranceUserState.checked)
    //     {
    //         alert("利用契約・プライバシーポリシーに同意の上、お進みください。");
    //         return;
    //     }

    //     //localStorageにEntranceUserからの遷移かどうかの情報を保存（ログイン画面と区別）
    //     localStorage.setItem("EntranceUser", true);

    //     window.location.href = '/yahoojpLogin';
    // };

    return (
        <React.Fragment>
            <Typography variant="h2" align="center">
                会員登録
            </Typography>
            <Button size="small" variant="outlined" onClick={LinkClick}>
                戻る
            </Button>
            {/* <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                //sx={{ minHeight: "300px" }}
                style={{ display: EntranceUserState.send ? 'none' : '' }}
            >
                // { {"Yahoo! JAPAN IDのメールアドレス、もしくはご入力いただいたメールアドレスに、会員情報登録用URLを送信します。"} }
                {"ご入力いただいたメールアドレスに、会員情報登録用URLを送信します。"}
                <br/>
                {"受信設定をされている場合は「@～～～」のドメインを受信できるように設定をお願いいたします。"}
                <br/>
                <FormControlLabel
                    control={
                        <Checkbox
                            name="checked"
                            onChange={(e) => onChange({ name: "checked", value: e.target.checked })}
                            checked={EntranceUserState.checked ? true : false}
                        />
                    }
                    label={<span><a href="" target="_blank">利用規約</a>と<a href="" target="_blank">プライバシーポリシー</a>に同意する</span>}
                />
            </Grid> */}
            <Grid
                container
                //direction="column"
                justifyContent="center"
                //alignItems="center"
                sx={{ minHeight: "300px" }}
                style={{ display: EntranceUserState.send ? 'none' : '' }}
            >
                <form onSubmit={HandleSubmit} style={{padding: "1rem 1.3rem"}} >
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ border: 1, maxWidth: "30rem" }}
                    >
                        <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ p: 2 }}>
                            <TextField
                                required
                                sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                                label="メールアドレス"
                                variant="outlined"
                                name="email_address"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 60 }}
                                value={EntranceUserState.email_address}
                                onChange={(e) => onChange({ name: "email_address", value: e.target.value })}
                                type="email"
                            />
                        </Grid>
                        {"ご入力いただいたメールアドレスに、会員情報登録用URLを送信します。受信設定をされている場合は「@ml.yahoo-corp.jp」のドメインを受信できるように設定をお願いいたします。"}
                        <Button
                            variant="contained"
                            size="large"
                            color="primary"
                            sx={{ width: "8rem" }}
                            type="submit"
                            disabled={disabled}
                        >
                            URLを送信
                        </Button>
                    </Grid>
                </form>
                {/* <form onSubmit={YahooSubmit} id="ApplicationForm" style={{padding: "1rem 0rem"}}>
                    {"Yahoo! JAPAN IDで会員登録"}
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ border: 1, maxWidth: "50rem" }}
                    >
                        <Button
                            variant="contained"
                            size="large"
                            sx={{ width: "20rem", bgcolor: "#ff0033", m: 2 }}
                            type="submit"
                        >
                            <img
                                src="/images/Logo/yahoo_japan_icon_w_256.png"
                                width="30px"
                                style={{
                                    marginLeft: "0",
                                    marginRight: "auto",
                                    display: "block",
                                }}
                            />{"　"}
                            Yahoo! JAPAN IDで会員登録
                        </Button>
                        {"（すでにYahoo! JAPAN IDで登録済みの場合、ログインします）"}
                    </Grid>
                </form> */}
            </Grid>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ display: EntranceUserState.send ? '' : 'none' }}
            >
                <Grid
                    container
                    direction="column"
                    alignItems="center"
                    sx={{ minHeight: "200px", maxWidth: "350px" }}
                >
                    {"ご利用いただきありがとうございます。"}
                    <br/>
                    {"以下のメールアドレスで仮登録を行いました。"}
                    <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                        {EntranceUserState.email_address}
                    </Typography>
                    {"上記メールアドレス宛に、会員情報登録のためのURLをお送りしております。ご確認いただき、会員情報登録へとお進みください。"}
                </Grid>

                <a style={{ color: "red", textAlign: 'center' }} >
                    {"※ご注意"}
                </a>

                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    sx={{ minHeight: "100px", maxWidth: "350px" }}
                >
                    <a style={{ fontWeight: 'bold' }}>
                        {"会員情報登録の有効期限"}
                    </a>
                    <p>
                        {"会員情報登録の有効期限は12時間です。"}
                        <a style={{ color: "red"}} >
                            {"12時間以内に登録"}
                        </a>
                        {"を行ってください。"}
                    </p>
                </Grid>

                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ minHeight: "150px", maxWidth: "350px" }}
                >
                    <a style={{ fontWeight: 'bold' }}>
                        {"迷惑メール対策などでフィルター設定をしている場合"}
                    </a>
                    <li>
                        <a style={{ color: "red"}} >
                            {"迷惑メールフォルダやごみ箱に自動的に振り分けられている可能性"}
                        </a>
                        {"がありますので、ご確認をお願いいたします。"}
                    </li>
                    <li>
                        {"また、メールを受信できない場合がございますので"}
                        <a style={{ color: "red"}} >
                            {"「@ml.yahoo-corp.jp」を受信する設定"}
                        </a>
                        {"にしてください。"}
                    </li>
                </Grid>
            </Grid>
            {/* <Grid
                container
                direction="column"
                justifyContent="center"
                style={{ display: EntranceUserState.send ? 'none' : '' }}
            >
                {"Webサービス by Yahoo! JAPAN （https://developer.yahoo.co.jp/sitemap/）"}
            </Grid> */}
        </React.Fragment>
    );
};

export default EntranceUser;
